<template>
    <div class="pb-header">
        <!-- Bandeau haut -->
        <div class="topbar">
            <div class="container row">
                <div class="left">
                    <a href="/" aria-label="Facebook" target="_blank" rel="noopener noreferrer" class="social-button"><svg fill="currentColor" version="1.1" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32"><title>Facebook</title><path d="M31.997 15.999c0-8.836-7.163-15.999-15.999-15.999s-15.999 7.163-15.999 15.999c0 7.985 5.851 14.604 13.499 15.804v-11.18h-4.062v-4.625h4.062v-3.525c0-4.010 2.389-6.225 6.043-6.225 1.75 0 3.581 0.313 3.581 0.313v3.937h-2.017c-1.987 0-2.607 1.233-2.607 2.498v3.001h4.437l-0.709 4.625h-3.728v11.18c7.649-1.2 13.499-7.819 13.499-15.804z"></path></svg></a>
                    <a href="http://www.instagram.com/imprimbook" aria-label="Instagram" target="_blank" rel="noopener noreferrer" class="social-button"><svg fill="currentColor" version="1.1" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><title>Instagram</title><path d="M7 1c-1.657 0-3.158 0.673-4.243 1.757s-1.757 2.586-1.757 4.243v10c0 1.657 0.673 3.158 1.757 4.243s2.586 1.757 4.243 1.757h10c1.657 0 3.158-0.673 4.243-1.757s1.757-2.586 1.757-4.243v-10c0-1.657-0.673-3.158-1.757-4.243s-2.586-1.757-4.243-1.757zM7 3h10c1.105 0 2.103 0.447 2.828 1.172s1.172 1.723 1.172 2.828v10c0 1.105-0.447 2.103-1.172 2.828s-1.723 1.172-2.828 1.172h-10c-1.105 0-2.103-0.447-2.828-1.172s-1.172-1.723-1.172-2.828v-10c0-1.105 0.447-2.103 1.172-2.828s1.723-1.172 2.828-1.172zM16.989 11.223c-0.15-0.972-0.571-1.857-1.194-2.567-0.754-0.861-1.804-1.465-3.009-1.644-0.464-0.074-0.97-0.077-1.477-0.002-1.366 0.202-2.521 0.941-3.282 1.967s-1.133 2.347-0.93 3.712 0.941 2.521 1.967 3.282 2.347 1.133 3.712 0.93 2.521-0.941 3.282-1.967 1.133-2.347 0.93-3.712zM15.011 11.517c0.122 0.82-0.1 1.609-0.558 2.227s-1.15 1.059-1.969 1.18-1.609-0.1-2.227-0.558-1.059-1.15-1.18-1.969 0.1-1.609 0.558-2.227 1.15-1.059 1.969-1.18c0.313-0.046 0.615-0.042 0.87-0.002 0.74 0.11 1.366 0.47 1.818 0.986 0.375 0.428 0.63 0.963 0.72 1.543zM17.5 7.5c0.552 0 1-0.448 1-1s-0.448-1-1-1-1 0.448-1 1 0.448 1 1 1z"></path></svg></a>
                    <a href="http://www.linkedin.com/company/imprimbook" aria-label="Linkedin" target="_blank" rel="noopener noreferrer" class="social-button"><svg fill="currentColor" version="1.1" xmlns="http://www.w3.org/2000/svg" width="24" height="28" viewBox="0 0 24 28"><title>Linkedin</title><path d="M3.703 22.094h3.609v-10.844h-3.609v10.844zM7.547 7.906c-0.016-1.062-0.781-1.875-2.016-1.875s-2.047 0.812-2.047 1.875c0 1.031 0.781 1.875 2 1.875h0.016c1.266 0 2.047-0.844 2.047-1.875zM16.688 22.094h3.609v-6.219c0-3.328-1.781-4.875-4.156-4.875-1.937 0-2.797 1.078-3.266 1.828h0.031v-1.578h-3.609s0.047 1.016 0 10.844v0h3.609v-6.062c0-0.313 0.016-0.641 0.109-0.875 0.266-0.641 0.859-1.313 1.859-1.313 1.297 0 1.813 0.984 1.813 2.453v5.797zM24 6.5v15c0 2.484-2.016 4.5-4.5 4.5h-15c-2.484 0-4.5-2.016-4.5-4.5v-15c0-2.484 2.016-4.5 4.5-4.5h15c2.484 0 4.5 2.016 4.5 4.5z"></path></svg></a>
                </div>

                <div class="right">
                    <a @click.prevent="toggleSection('account')" id="header-account" ref="accountToggle"
                       class="toolbar-toggle" :class="{ active: isAccountSectionActive }" href="#header-account-panel"
                       style="background: url('https://imprimbook.fr/wp-content/uploads/2025/09/icone_profil-client_blanc.png') left center / 20px 20px no-repeat;color: #ffffff;text-decoration: none;font-size: 12px;text-transform: uppercase;font-family: 'Nexa Regular',Nexa,Arial,sans-serif;font-weight: 600;line-height: 20px;padding-left: 28px;margin-right: 60px!important">
                        Mon compte
                    </a>
                    <a @click.prevent="toggleSection('cart')" id="header-user-cart" ref="cartToggle"
                       class="cart toolbar-toggle" :class="{ active: isCartSectionActive }" href="#header-user-cart-panel"
                       style="background: url('https://imprimbook.fr/wp-content/uploads/2025/09/icone_panier_blanc.png') left center / 20px 20px no-repeat;color: #ffffff;text-decoration: none;font-size: 12px;text-transform: uppercase;font-family: 'Nexa Regular',Nexa,Arial,sans-serif;font-weight: 600;line-height: 20px;padding-left: 28px">
                        Mon Panier
                        <transition name="fade" mode="out-in">
                            <span v-if="user.isCartEnabled" class="count">{{cartProductQuantity}}</span>
                        </transition>
                    </a>
                    <div class="toolbar-dropdown" :class="{ open: isSideBarOpen }" ref="sidebar" >
                        <Account @show-forgot-password-modal="$emit('show-forgot-password-modal')"/>
                        <HeaderShopCart @click-login="$refs.accountToggle.click()"/>
                    </div>
                    <div
                        v-if="isSideBarOpen"
                        class="sidebar-backdrop"
                        @click="closeSidebar"
                    />
<!--
                    <a :href="accountHref" style="background: url('https://imprimbook.fr/wp-content/uploads/2025/09/icone_profil-client_blanc.png') left center / 20px 20px no-repeat;color: #ffffff;text-decoration: none;font-size: 12px;text-transform: uppercase;font-family: 'Nexa Regular',Nexa,Arial,sans-serif;font-weight: 600;line-height: 20px;padding-left: 28px;margin-right: 60px!important">SMON COMPTE</a>
                    <a :href="cartHref" class="cart" style="background: url('https://imprimbook.fr/wp-content/uploads/2025/09/icone_panier_blanc.png') left center / 20px 20px no-repeat;color: #ffffff;text-decoration: none;font-size: 12px;text-transform: uppercase;font-family: 'Nexa Regular',Nexa,Arial,sans-serif;font-weight: 600;line-height: 20px;padding-left: 28px">MON PANIER</a>
                    -->

                </div>
            </div>
        </div>

        <!-- Barre principale -->
        <div class="mainbar">
            <div class="container row">
                <a class="logo" :href="homeHref">
                    <img :src="logoSrc" :alt="logoAlt" width="408" height="102">
                </a>

                <!-- NAV DESKTOP -->
                <nav class="nav pipes desktop-nav" aria-label="Navigation principale">
                    <ul class="nav-list">
                        <li>
                            <a href="https://imprimbook.fr/index.php/preparer-mon-fichier/" rel="noopener">Préparer mon fichier</a>
                        </li>
                        <li :class="{ active: inSelfPublishingFlow($route.name) }">
                            <router-link to="/self-publishing/create-book">Imprimer mon livre</router-link>
                        </li>
                        <li :class="{ active: $route.name === 'selfPublishingBooks' }">
                            <router-link to="/self-publishing/books">Ma Bibliothèque</router-link>
                        </li>
                        <transition name="fade">
                            <li v-if="isUserLogged" :class="{ active: $route.name === 'profileOrders' }">
                                <router-link to="/profile/orders">Mes commandes</router-link>
                            </li>
                        </transition>
                        <transition name="fade">
                            <li v-if="isUserLogged && user && user.isAdmin" :class="{ active: isAdminRoute }">
                                <router-link to="/administration">Administration</router-link>
                            </li>
                        </transition>
                        <li v-if="!user.isAdmin">
                            <a href="https://imprimbook.fr/index.php/tout-pour-votre-com/"  rel="noopener">Tout pour ma com’</a>
                        </li>
                        <li v-if="!user.isAdmin">
                            <a href="https://imprimbook.fr/index.php/impression-de-livres-ecoresponsable/" rel="noopener">Eco friendly</a>
                        </li>
                        <li>
                            <a href="https://imprimbook.fr/index.php/contact/">Contact</a>
                        </li>
                        <li>
                            <a href="https://imprimbook.fr/index.php/sample-page/" rel="noopener">Blog</a>
                        </li>
                    </ul>
                </nav>

                <!-- BOUTON HAMBURGER (mobile only) -->
                <button class="hamburger" :class="{ 'is-active': isMobileMenuOpen }"
                        @click="toggleMobileMenu" aria-label="Ouvrir le menu" aria-expanded="isMobileMenuOpen.toString()">
                    <span></span><span></span><span></span>
                </button>
            </div>
        </div>

        <!-- MENU MOBILE -->
        <transition name="slide-fade">
            <nav v-if="isMobileMenuOpen" class="mobile-nav" ref="mobileNav" aria-label="Navigation mobile">
                <ul>
                    <li>
                        <a href="https://imprimbook.fr/index.php/preparer-mon-fichier/" rel="noopener" @click="handleDocumentClick">Préparer mon fichier</a>
                    </li>
                    <li :class="{ active: inSelfPublishingFlow($route.name) }">
                        <router-link to="/self-publishing/create-book" @click.native="handleDocumentClick">Imprimer mon livre</router-link>
                    </li>
                    <li :class="{ active: $route.name === 'selfPublishingBooks' }">
                        <router-link to="/self-publishing/books" @click.native="handleDocumentClick">Ma Bibliothèque</router-link>
                    </li>
                    <li v-if="isUserLogged" :class="{ active: $route.name === 'profileOrders' }">
                        <router-link to="/profile/orders" @click.native="handleDocumentClick">Mes commandes</router-link>
                    </li>
                    <li v-if="isUserLogged && user && user.isAdmin" :class="{ active: isAdminRoute }">
                        <router-link to="/administration" @click.native="handleDocumentClick">Administration</router-link>
                    </li>
                    <li v-if="!user.isAdmin">
                        <a href="https://imprimbook.fr/index.php/tout-pour-votre-com/" rel="noopener" @click="handleDocumentClick">Tout pour ma com’</a>
                    </li>
                    <li v-if="!user.isAdmin">
                        <a href="https://imprimbook.fr/index.php/impression-de-livres-ecoresponsable/" rel="noopener" @click="handleDocumentClick">Eco friendly</a>
                    </li>
                    <li>
                        <a href="https://imprimbook.fr/index.php/contact/" @click="handleDocumentClick">Contact</a>
                    </li>
                    <li>
                        <a href="https://imprimbook.fr/index.php/sample-page/" rel="noopener" @click="handleDocumentClick">Blog</a>
                    </li>
                </ul>
            </nav>
        </transition>
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { inAdministrationSection, inSelfPublishingFlow } from "@/helpers/section";
import { isCartFullOfProductsWithAgreement } from "@/helpers/user";
import Account from "@/components/Hermes/Header/Account/Account.vue";
import HeaderShopCart from "@/components/Hermes/Header/HeaderShopCart/HeaderShopCart.vue";

export default {
    name: "ImprimBookTopHeader",
    components: {HeaderShopCart, Account},
    data() {
        return {
            isMobileMenuOpen: false,
        };
    },
    props: {
        homeHref: { type: String, default: "https://imprimbook.fr" },
        logoSrc: { type: String, default: "https://imprimbook.fr/wp-content/uploads/2025/09/LOGO-INLINE-300x75.png" },
        logoAlt: { type: String, default: "imprimbook.fr" },
        navLinks: {
            type: Array,
            default: function() {
                return [
                    { label: "Préparer mon fichier", href: "https://imprimbook.fr/index.php/preparer-mon-fichier/" },
                    { label: "Imprimer mon livre", href: "/self-publishing/create-book" },
                    { label: "Ma Bibliothèque", href: "/self-publishing/books" },
                    { label: "Tout pour ma com'", href: "https://imprimbook.fr/index.php/tout-pour-votre-com/" },
                    { label: "Eco friendly", href: "https://imprimbook.fr/index.php/impression-de-livres-ecoresponsable/" },
                    { label: "Contact", href: "https://imprimbook.fr/index.php/contact/" },
                    { label: "Blog", href: "https://imprimbook.fr/index.php/sample-page/" },
                ];
            },
        },
        accountHref: { type: String, default: "/profile/orders" },
        cartHref: { type: String, default: "#" },
        cartCount: { type: Number, default: 0 },
    },
    computed: {
        ...mapGetters("user", {
            user: "user",
            isUserLogged: "isLogged",
            userCart: "cart",
        }),
        ...mapGetters("sideBarMenu", {
            isSideBarOpen: "isSideBarOpen",
            isMobileNavSectionActive: "isMobileNavSectionActive",
            isSearchSectionActive: "isSearchSectionActive",
            isAccountSectionActive: "isAccountSectionActive",
            isCartSectionActive: "isCartSectionActive",
        }),
        isAdminRoute() {
            return inAdministrationSection(this.$route.name);
        },
        cartProductQuantity() {
            const count = this.userCart ? this.userCart.length : 0;
            return count < 10 ? count : `9+`;
        },
    },
    watch: {
        // Ferme le menu au changement de route
        $route() {
            this.isMobileMenuOpen = false;
        },
    },
    mounted() {
        document.addEventListener("click", this.handleDocumentClick);
    },
    beforeDestroy() {
        document.removeEventListener("click", this.handleDocumentClick);
    },
    methods: {
        inSelfPublishingFlow,
        toggleMobileMenu() {
            this.isMobileMenuOpen = !this.isMobileMenuOpen;
        },
        closeSidebar() {
            if (this.isAccountSectionActive) {
                this.toggleSection("account");
            } else if (this.isCartSectionActive) {
                this.toggleSection("cart");
            } else if (this.isSearchSectionActive) {
                this.toggleSection("search");
            } else if (this.isMobileNavSectionActive) {
                this.toggleSection("mobileNav");
            }
        },
        handleDocumentClick(event) {
            const target = event.target;

            // --- MENU MOBILE ---
            if (this.isMobileMenuOpen) {
                const mobileNav = this.$refs.mobileNav;
                const burger = this.$el.querySelector(".hamburger");

                const clickInsideMobile =
                    mobileNav && mobileNav.contains(target) ||
                    burger && burger.contains(target);

                if (!clickInsideMobile) {
                    this.isMobileMenuOpen = false; // ferme le menu mobile
                }
            }

            // --- SIDEBAR COMPTE/PANIER ---
            if (this.isSideBarOpen) {
                const sidebar = this.$refs.sidebar;
                const accountBtn = this.$refs.accountToggle;
                const cartBtn = this.$refs.cartToggle;

                const clickInsideSidebar =
                    sidebar && sidebar.contains(target) ||
                    accountBtn && accountBtn.contains(target) ||
                    cartBtn && cartBtn.contains(target);

                if (!clickInsideSidebar) {
                    this.toggleSection(null);
                }
            }
        },
        isCartFullOfProductsWithAgreement,
        ...mapActions("sideBarMenu", { toggleSection: "toggleSection" }),
    },
};
</script>

<style scoped>
.row{ display:flex; align-items:center; justify-content:space-between; gap:1px; }
.topbar {
    background: #36485C;
    color: #dce6ec;
    font-size: 13px;
}
.topbar > .container {
    width: 80%;
    max-width: 1260px;
    margin: 0 auto;

    display: flex;
    align-items: center;
    justify-content: space-between;
}

.left{ display:flex; align-items:center; gap:1px; }
.right{ display:flex; align-items:center; gap:1px; }

.account,.cart{
    display:flex; align-items:center; gap:8px;
    color:#fff; text-decoration:none;
    font-size:13px;             /* = topbar font-size */
    font-weight:600;            /* = follow (gras) */
}
.account:hover,.cart:hover{ opacity:.9; }

.mainbar {
    background:#fff;
    border-bottom:1px solid #eef3f5;
}

.mainbar > .container {
    width: 80%;
    max-width: 1280px;
    margin: 0 auto;
}
.logo{
    display:flex; align-items:center; gap:0;
    text-decoration:none; color:#DEC38F; font-weight:800;
    padding:10px 0;
}
.logo img{
    width:250px; height:63px; object-fit:contain; /* logo seul */
}

.nav{ display:flex; align-items:center; flex-wrap:wrap; }
.nav a{
    position: relative;
    display: inline-block;
    font-style: normal;
    font-family: "Nexa Regular",Nexa,Arial,sans-serif;
    font-weight: 500;
    text-decoration:none;
    color:#36485c;
    font-size:12px;
    text-transform:uppercase;
    padding: .6em calc(1.2em / 2);
}
.nav a::after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    width: 0;
    margin: auto;
    height: 2px;
    background: #DEC38F;
    transition: width 0.3s ease;
}
.nav a:hover {
    color: #DEC38F;
}
.nav a:hover::after {
    width: 100%;
}
.nav li.active > a,
.nav a.router-link-active,
.nav a.router-link-exact-active {
    color: #DEC38F;
}
.nav li.active > a::after,
.nav a.router-link-active::after,
.nav a.router-link-exact-active::after {
    width: 100%;
}
.pipes a + a{
    position:relative;
    margin-left:5px;
    padding-left:5px;
}

.nav-list {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    gap: 2px;
    align-items: center;
}

a.social-button svg {
    height: 1em;
    width: 1em;
    color: #ffffff;
}

a.social-button svg:hover {
    height: 1em;
    width: 1em;
    color: #DEC38F;
    transition: all .2s ease-in-out
}
.hamburger{
    display: none;
    width: 20px; height: 20px;
    border: none; background: transparent;
    padding: 0; margin: 0 0 0 4px;
    position: relative; cursor: pointer;
    opacity: 0.7;
}
.hamburger span{
    position: absolute; left: 0; right: 0;
    height: 2px; background: #36485c;
    display: block; transition: transform .25s ease, opacity .2s ease, top .25s ease;
}
.hamburger span:nth-child(1){ top: 8px; }
.hamburger span:nth-child(2){ top: 14px; }
.hamburger span:nth-child(3){ top: 20px; }
.hamburger.is-active span:nth-child(1){
    top: 16px; transform: rotate(45deg);
}
.hamburger.is-active span:nth-child(2){
    opacity: 0;
}
.hamburger.is-active span:nth-child(3){
    top: 16px; transform: rotate(-45deg);
}

/* ---- Menu mobile ---- */
.mobile-nav{
    position: fixed;
    right: 0;
    top: 115px;
    height: calc(100vh - 120px);
    width: 80%;
    background: #36485c;
    border-left: 1px solid rgba(255,255,255,.1);
    box-shadow: -6px 0 16px rgba(0,0,0,.2);
    z-index: 900;
}
.mobile-nav ul{
    list-style: none; margin: 0; padding: 8px 5%;
    display: flex; flex-direction: column; gap: 4px;
}
.mobile-nav a, .mobile-nav .router-link-active{
    display: block;
    padding: 10px 8px;
    font-family: "Nexa Regular", Nexa, Arial, sans-serif;
    font-size: 14px;
    text-transform: uppercase;
    color: #ffffff; text-decoration: none;
}
.mobile-nav a:hover, .mobile-nav .router-link-active{
    color: #DEC38F;
}

/* ---- Transition slide-fade ---- */
.slide-fade-enter-active,
.slide-fade-leave-active {
    transition: transform .25s ease, opacity .25s ease;
}
.slide-fade-enter,
.slide-fade-leave-to {
    transform: translateX(100%);   /* glisse depuis la droite */
    opacity: 0;
}

.right .toolbar-toggle{
    display: inline-flex;
    align-items: center;
    gap: 8px;
    color: #fff;
    text-decoration: none;
    font-size: 12px;
    font-weight: 600;
    line-height: 20px;
    padding-left: 0;
    position: relative;
}

.right .toolbar-toggle .material-icons{
    font-size: 18px;
    line-height: 1;
}

.right .toolbar-toggle .label{
    text-transform: uppercase;
}

.right .toolbar-toggle .count{
    position: absolute;
    top: -6px;
    right: -20px;
    min-width: 18px;
    height: 18px;
    border-radius: 999px;
    background: #DEC38F;
    color: #fff;
    font-size: 11px;
    line-height: 21px;
    text-align: center;
    padding: 0 5px;
}

.toolbar-dropdown{
    position: fixed;
    top: 31px;
    right: 0;
    width: 380px;
    height: calc(100vh - 31px);
    background: #fff;
    box-shadow: 0 3px 50px rgba(0,0,0,.15);
    transition: opacity .35s, visibility .35s, transform .35s;
    opacity: 0; visibility: hidden;
    overflow-y: auto;
    z-index: 9999;
}
.toolbar-dropdown.open{
    opacity: 1; visibility: visible;
}

.toolbar-dropdown >>> label,
.toolbar-dropdown >>> span:not(button span),
.toolbar-dropdown >>> .font-italic,
.toolbar-dropdown >>> .text-sm {
    color: #36485c;
}

.sidebar-backdrop{
    position: fixed;
    inset: 0;
    background: rgba(0,0,0,.3);
    z-index: 9998;
}

@media (min-width: 861px){
    .mobile-nav{ display: none !important; }
}

@media (max-width: 860px){
    .desktop-nav{ display: none; }
    .hamburger{ display: inline-block; }
}
</style>